export default __webpack_public_path__ + "static/media/register-visitor-oq-logo.77747fbf.png";